export interface CountryData {
  name: string;
  region: 'ASIA' | 'EUROPE';
}

export const COUNTRIES: CountryData[] = [
  // Asia & Middle East
  { name: 'India', region: 'ASIA' },
  { name: 'China', region: 'ASIA' },
  { name: 'Japan', region: 'ASIA' },
  { name: 'Singapore', region: 'ASIA' },
  { name: 'Malaysia', region: 'ASIA' },
  { name: 'Thailand', region: 'ASIA' },
  { name: 'Indonesia', region: 'ASIA' },
  { name: 'Vietnam', region: 'ASIA' },
  { name: 'Philippines', region: 'ASIA' },
  { name: 'South Korea', region: 'ASIA' },
  { name: 'Bangladesh', region: 'ASIA' },
  { name: 'Pakistan', region: 'ASIA' },
  { name: 'Sri Lanka', region: 'ASIA' },
  { name: 'Nepal', region: 'ASIA' },
  { name: 'Myanmar', region: 'ASIA' },
  { name: 'Cambodia', region: 'ASIA' },
  
  // Middle East
  { name: 'United Arab Emirates', region: 'ASIA' },
  { name: 'Saudi Arabia', region: 'ASIA' },
  { name: 'Qatar', region: 'ASIA' },
  { name: 'Kuwait', region: 'ASIA' },
  { name: 'Bahrain', region: 'ASIA' },
  { name: 'Oman', region: 'ASIA' },
  { name: 'Jordan', region: 'ASIA' },
  { name: 'Lebanon', region: 'ASIA' },
  { name: 'Israel', region: 'ASIA' },
  { name: 'Turkey', region: 'ASIA' },
  
  // Europe
  { name: 'United Kingdom', region: 'EUROPE' },
  { name: 'Germany', region: 'EUROPE' },
  { name: 'France', region: 'EUROPE' },
  { name: 'Italy', region: 'EUROPE' },
  { name: 'Spain', region: 'EUROPE' },
  { name: 'Netherlands', region: 'EUROPE' },
  { name: 'Belgium', region: 'EUROPE' },
  { name: 'Switzerland', region: 'EUROPE' },
  { name: 'Austria', region: 'EUROPE' },
  { name: 'Sweden', region: 'EUROPE' },
  { name: 'Norway', region: 'EUROPE' },
  { name: 'Denmark', region: 'EUROPE' },
  { name: 'Finland', region: 'EUROPE' },
  { name: 'Poland', region: 'EUROPE' },
  { name: 'Ireland', region: 'EUROPE' },
  { name: 'Portugal', region: 'EUROPE' },
  { name: 'Greece', region: 'EUROPE' },
  { name: 'Czech Republic', region: 'EUROPE' },
  { name: 'Romania', region: 'EUROPE' },
  { name: 'Hungary', region: 'EUROPE' },
  
  // Americas (default to EUROPE contact)
  { name: 'United States', region: 'EUROPE' },
  { name: 'Canada', region: 'EUROPE' },
  { name: 'Mexico', region: 'EUROPE' },
  { name: 'Brazil', region: 'EUROPE' },
  { name: 'Argentina', region: 'EUROPE' },
  { name: 'Chile', region: 'EUROPE' },
  { name: 'Colombia', region: 'EUROPE' },
  
  // Oceania (default to EUROPE contact)
  { name: 'Australia', region: 'EUROPE' },
  { name: 'New Zealand', region: 'EUROPE' },
  
  // Africa (default to EUROPE contact)
  { name: 'South Africa', region: 'EUROPE' },
  { name: 'Nigeria', region: 'EUROPE' },
  { name: 'Kenya', region: 'EUROPE' },
  { name: 'Egypt', region: 'EUROPE' },
  { name: 'Morocco', region: 'EUROPE' },
];

export const getRegionByCountry = (country: string): 'ASIA' | 'EUROPE' => {
  const normalizedCountry = country.toLowerCase().trim();
  const foundCountry = COUNTRIES.find(
    c => c.name.toLowerCase() === normalizedCountry
  );
  return foundCountry ? foundCountry.region : 'EUROPE'; // Default to EUROPE
};
